// Canonical set of advisor form fields that actually feed the generated
// System-Access mail. The subject (backend `buildEmailSubject`) uses
// name/surname/agent_id; the body placeholders (SystemActionDialog
// `replacePlaceholders`) additionally use the address block, country, office and
// the two e-mail fields. Only edits to THESE fields can make the live-form body
// diverge from the saved-record subject — so only these must block sending while
// unsaved (RITA-1307 Review P2).
//
// Formik's global `dirty` over-blocks: editing an unrelated field (dismissal
// status, another tab's data) would needlessly disable "Sofort senden" and
// "Terminieren" even though subject and body would be identical. Deriving the
// guard from this subset keeps the dirty-form protection (RITA-1307) without
// blocking unrelated edits.
export const MAIL_RELEVANT_ADVISOR_FIELDS = [
  'name',
  'surname',
  'agent_id',
  'address',
  'zip',
  'city',
  'country_id',
  'branch_office_id',
  'email_corp',
  'email_private',
] as const;

export type MailRelevantAdvisorField = (typeof MAIL_RELEVANT_ADVISOR_FIELDS)[number];

// True when any mail-relevant advisor field differs from its saved value, i.e.
// an unsaved edit that could make the live-form mail body disagree with the
// backend-derived subject. Decoupled from Formik so it stays unit-testable.
export function isMailDataDirty<T extends Record<MailRelevantAdvisorField, unknown>>(
  values: T,
  initialValues: T,
): boolean {
  return MAIL_RELEVANT_ADVISOR_FIELDS.some((field) => values[field] !== initialValues[field]);
}

export default isMailDataDirty;
